// src/components/ModalNewPet.js

import './ModalNewPet.css';

export default function ModalNewPet() {

  return (
    <div className="modal-new-pet">
      <header className="modal-new-pet__header">
        <h2 className="modal-new-pet__title">Nueva Mascota</h2>
      </header>
      <div className="modal-new-pet__body">
        <p>Aquí podrás rellenar los datos para dar de alta una nueva mascota.</p>
        {/* más adelante podrías poner el formulario aquí */}
      </div>
    </div>
  );
}
